import { styled } from 'styled-components';

import { FormSection } from '#/components/Form/FormSection';
import { colors, transition } from '#/theme/theme';

export const PreviousErrorsSection = styled(FormSection)`
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 0;
    transform: translateY(5px);
    width: 100%;
    height: 100%;
    background: ${colors.alertRed};
    transition: all ${transition};
  }
`;
